import 'bootstrap/dist/css/bootstrap.min.css';
import resident from "../newservice/image/residential.jpg"
import commercial from "../newservice/image/commercial.jpg"
import exterior from "../newservice/image/exterior.webp"
import interior from "../newservice/image/interior.jpeg"
import surface from "../newservice/image/surface.jpg"
import speciality from "../newservice/image/speciality.jpeg"
import staining from "../newservice/image/staining.jpeg"
import paint from '../video/paint.mp4'
import paint1 from '../video/paint1.mp4'

import ptbg from '../video/paintbg1.avif'
import { useState, useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaPaintRoller, FaUsers, FaStar, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

import logo from "../newservice/image/staining.jpeg"; // Your logo
// import team1 from "https://www.nicepng.com/png/full/413-4138963_unknown-person-png.png";
// import team2 from "https://www.kindpng.com/picc/m/52-526043_unknown-person-png-transparent-png.png";

import gallery1 from "../newservice/image/interior.jpeg";
import gallery2 from "../newservice/image/staining.jpeg";
import gallery3 from "../newservice/image/commercial.jpg";
import gallery4 from "../newservice/image/exterior.webp";
import bgImage from '../video/paintbg1.avif'; // You can replace with your background
const team1= "https://www.nicepng.com/png/full/413-4138963_unknown-person-png.png";
const team2= "https://www.kindpng.com/picc/m/52-526043_unknown-person-png-transparent-png.png";

const imgStyle = {
  backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.3)), url(${bgImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  color: 'white',
  textAlign: 'center',
  padding: '70px 20px',
};

const sectionStyle = {
  background: 'linear-gradient(135deg, #f21067, #42c1c1, #00a2ff)',
  color: 'white',
  textAlign: 'center',
  padding: '10px',
  borderRadius: '8px',
  marginBottom: '1rem'
};

const services = [
  {
    title: 'Interior Painting',
    features: [
      'Wall and ceiling painting',
      'Color consultation',
      'Surface preparation and priming',
      'Eco-friendly paints available',
    ],
  },
  {
    title: 'Exterior Painting',
    features: [
      'Surface cleaning and repair',
      'Weather-resistant coatings',
      'Fence and deck painting',
      'Durable, long-lasting finishes',
    ],
  },
  {
    title: 'Commercial Painting',
    features: [
      'Office and retail spaces',
      'Industrial coatings',
      'Flexible scheduling',
      'Minimal disruption service',
    ],
  },
  {
    title: 'Specialty Finishes',
    features: [
      'Texture and faux finishes',
      'Decorative murals',
      'Custom color matching',
      'Cabinet and furniture painting',
    ],
  },
];

const faqs = [
  {
    question: 'Do you provide free color consultations?',
    answer: 'Yes! We offer free consultations to help you choose the perfect colors and finishes for your space.',
  },
  {
    question: 'How do you prepare surfaces before painting?',
    answer: 'We thoroughly clean, sand, and prime surfaces to ensure the paint adheres well and lasts longer.',
  },
  {
    question: 'Are your paints eco-friendly?',
    answer: 'We use low-VOC and environmentally friendly paints upon request to ensure safety and sustainability.',
  },
  {
    question: 'What areas do you serve?',
    answer: 'We provide painting services across Your City/Region and neighboring areas.',
  },
  {
    question: 'Can I request a custom mural or decorative finish?',
    answer: 'Absolutely! We have skilled artists and painters who specialize in custom finishes and murals.',
  },
];

const PainterServices = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);

  return (
    <div>
      {/* Header */}
      {/* <nav className="navbar navbar-expand-lg navbar-dark bg-dark py-3 shadow-sm fixed-top">
        <div className="container">
          <a className="navbar-brand d-flex align-items-center" href="#">
            <img src={logo} alt="Logo" width="40" className="me-2" />
            <strong>OneStopService</strong>
          </a>
          <button className="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item"><a className="nav-link" href="#about">About</a></li>
              <li className="nav-item"><a className="nav-link" href="#services">Services</a></li>
              <li className="nav-item"><a className="nav-link" href="#team">Team</a></li>
              <li className="nav-item"><a className="nav-link" href="#gallery">Gallery</a></li>
              <li className="nav-item"><a className="nav-link" href="#testimonials">Testimonials</a></li>
              <li className="nav-item"><a className="nav-link" href="#contact">Contact</a></li>
            </ul>
          </div>
        </div>
      </nav> */}

      <div style={{ marginTop: '80px' }}></div> {/* spacing for fixed navbar */}

      {/* Hero Section */}
      <section style={imgStyle}>
        <h1 className="display-3 fw-bold" style={{color:'#d4af37'}}><FaPaintRoller /> Expert Painting Services</h1>
        <p className="lead mt-3">
          Transform your home or business with professional, reliable, and beautiful painting solutions.
        </p>
        <a href="#contact" className="btn btn-lg btn-primary mt-3">Request a Quote</a>
      </section>


      {/* About Section */}
      <section id="about" className="my-5 p-4 bg-light text-dark rounded shadow-sm container">
        <h2 className="text-center mb-3" style={{color:'#d4af37',backgroundColor:'#0b3d2e'}}>About OneStopService Painting</h2>
        <p>
          At OneStopService, we bring over a decade of experience in residential and commercial painting. Our team is
          passionate about delivering impeccable results with attention to detail, using the best materials and
          techniques.
        </p>
        <p>
          Whether you want a fresh interior look or durable exterior finishes, our experts will ensure your vision is
          realized with minimal disruption and maximum satisfaction.
        </p>
      </section>

      {/* Services Section */}
      <section id="services" className="container my-5">
        <h2 className='text-center' style={{color:'#d4af37',backgroundColor:'#0b3d2e'}}>🎨 Our Painting Services</h2>
        <div className="row">
          {services.map((service, idx) => (
            <div className="col-md-6 col-lg-3 mb-4" key={idx} data-aos="zoom-in">
              <div className="card h-100 shadow-sm">
                <div className="card-body">
                  <h5 className="card-title">{service.title}</h5>
                  <ul className="list-unstyled">
                    {service.features.map((feat, i) => (
                      <li key={i}>• {feat}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Team Section */}
      <section id="team" className="container text-center my-5">
        <h2 style={{color:'#d4af37',backgroundColor:'#0b3d2e',textAlign:'center'}}><FaUsers /> Meet Our Team</h2>
        <div className="row justify-content-center">
          {[team1, team2].map((member, idx) => (
            <div className="col-md-4 mb-3" key={idx} data-aos="fade-up">
              <div className="card border-0 shadow-sm">
                <img src={member} className="card-img-top" alt={`Team member ${idx + 1}`} />
                <div className="card-body">
                  <h5 className="card-title">Painter {idx + 1}</h5>
                  <p className="text-muted">Expert in residential & commercial finishes.</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="container my-5 bg-light rounded p-4 shadow-sm text-center">
        <h2 style={{color:'#d4af37',backgroundColor:'#0b3d2e',textAlign:'center'}}>Project Gallery</h2>
        <div className="row">
          {[gallery1, gallery2, gallery3,gallery4].map((img, idx) => (
            <div className="col-md-4 mb-4" key={idx} data-aos="zoom-in">
              <img src={img} alt={`Gallery ${idx + 1}`} className="img-fluid rounded shadow" />
            </div>
          ))}
        </div>
      </section>
{/* Dual Video Showcase Section */}
<section className="container-fluid my-5">
  {/* Optional Text Overlay */}
  <div className="text-center mt-4">
    <h2 className="fw-bold" style={{color:'#d4af37',backgroundColor:'#0b3d2e'}}> Watch Our Team in Action</h2>
    <p className="lead">See how we transform interiors & exteriors with precision and passion.</p>
  </div>
  <div className="row">
    {/* Left Video */}
    <div className="col-md-6 p-0" style={{ overflow: 'hidden', height: '350px' }}>
      <video
        src={paint}
        autoPlay
        muted
        loop
        playsInline
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }}
      />
    </div>

    {/* Right Video */}
    <div className="col-md-6 p-0" style={{ overflow: 'hidden', height: '350px' }}>
      <video
        src={paint1}
        autoPlay
        muted
        loop
        playsInline
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }}
      />
    </div>
  </div>

  
</section>
      {/* Testimonials Section */}
      <section id="testimonials" className="container my-5 text-center">
        <h2 style={{color:'#d4af37',backgroundColor:'#0b3d2e'}}><FaStar /> What Our Clients Say</h2>
        <div className="row justify-content-center">
          {[
            { name: 'Jamal.', review: 'Excellent service, flawless finish. Highly recommend!' },
            { name: 'Kamran.', review: 'The team was professional, clean, and efficient. Loved the results!' },
          ].map((t, idx) => (
            <div className="col-md-5 mb-3" key={idx} data-aos="fade-up">
              <div className="card p-3 shadow-sm">
                <p>"{t.review}"</p>
                <h6 className="mt-2 mb-0">{t.name}</h6>
                <small className="text-muted">Verified Customer</small>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* FAQ Section */}
      <section className="container my-5">
        <h2 style={{color:'#d4af37',backgroundColor:'#0b3d2e',textAlign:'center'}}>❓ Frequently Asked Questions</h2>
        <div className="accordion" id="faqAccordion">
          {faqs.map((faq, index) => (
            <div className="card my-2" key={index}>
              <div
                className="card-header"
                style={{ cursor: 'pointer', backgroundColor: '#f1f1f1' }}
                onClick={() => toggleFAQ(index)}
              >
                <h5 className="mb-0 d-flex justify-content-between align-items-center">
                  {faq.question}
                  <span>{openIndex === index ? '−' : '+'}</span>
                </h5>
              </div>
              {openIndex === index && (
                <div className="card-body" style={{ backgroundColor: 'white', color: '#333' }}>
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="container my-5 text-center text-dark rounded">
        <h2><FaPhoneAlt /> Get In Touch</h2>
        <p className="lead">Need a quote or consultation?</p>
        <p>
          <FaPhoneAlt /> <a href="tel:+919199245536" className="text-warning">+91 91992 45536</a><br />
          <FaEnvelope /> <a href="mailto:gyasuddinali0786@gmail.com.com" className="text-info">gyasuddinali0786@gmail.com</a>
        </p>
        <a href="/contact" className="btn btn-outline-light mt-3">Request a Callback</a>
      </section>
    </div>
  );
};

export default PainterServices;
